<hbo-datatable-smart *ngIf="horizonsTeams$ | async as horizonsTeams"
  [columns]="['id', 'name']"
  [items]="horizonsTeams" (reload)="searchHorizonsTeams($event, true)"
>
  <tbody class="table-group-divider accordion" id="accordionHorizonsTeam">
    <ng-container *ngFor="let horizonsTeam of horizonsTeamsCollection$">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse-' + horizonsTeam.id"> </button></th>
        <td>{{ horizonsTeam.id }}</td>
        <td>{{ horizonsTeam.name }}</td>
      </tr>
      <tr class="row-body">
        <td colspan="6" class="bg-light p-0">
          <div [id]="'collapse-' + horizonsTeam.id" class="accordion-collapse collapse" data-bs-parent="#accordionHorizonsTeam">
            <div class="accordion-body">
              <hbo-horizons-team-actions [horizonsTeam]="horizonsTeam" (reload)="searchHorizonsTeams({}, true)" (callback)="callback($event)"></hbo-horizons-team-actions>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!horizonsTeams.data.length">
      <td colspan="6" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>
